'use client';

import { FC, useEffect } from 'react';

import { getLogger } from '@ravago/shared/logging/client';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import '@ravago/shared/radiance/styles.css';

import { loadFonts } from '../lib/utils/custom-fonts';

const Error: FC<{ error: Error & { digest?: string }; reset: () => void }> = ({ error, reset }) => {
  useEffect(() => {
    getLogger().withError(error).withMetadata({ digest: error.digest }).error(error.message);
  }, [error]);

  return (
    <html lang="en" className={`theme-ravago-one ${loadFonts('ravago-one')}`}>
      <head>
        <link rel="stylesheet" href="/themes/ravago-one.css" />
      </head>
      <body style={{ display: 'flex', justifyContent: 'center', height: '100vh' }}>
        <Box direction="column" justify="center" items="center" gap="md" maxWidth="400px">
          <Typography variant="heading-2" align="center">
            Something went wrong
          </Typography>
          <Typography variant="body" align="center">
            We apologize for the inconvenience.
            <br /> An unexpected error occurred while loading this page.
          </Typography>
          <Button onClick={() => reset()}>Reload page</Button>
        </Box>
      </body>
    </html>
  );
};

export default Error;
